<template>
    <div class="">

        <section class="avater-section"
            :class="(locale == 'ar') ? 'rtl' : 'ltr' ">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="box-avater text-center">
                            <br/><br/><br/>
                            <img alt="error" class="img-error mt-15" src="/assets/img/cancel.svg" style="height: 150px" loading="lazy" />
                            <h4 class="error-text text-center"><br/>فشل في عملية الدفع</h4>
                            <p><br/></p>
                            <div class="d-flex justify-content-around">
                                <div>
                                    <a
                                    :href="whatsAppNo"
                                    target="_blank"
                                    class="theme_btn theme_btn-whatsapp theme_btn_bg"
                                    style="background-color: #25D366 !important;"
                                    >{{ $t("app.contactUsToDonate") }}
                                    <span :style="[locale == 'en' ? { left: 'auto' } : {}]"
                                        ><i class="fab fa-whatsapp"></i
                                    ></span>
                                    </a>
                                    <br/><br/><br/>
                                </div>
                           
                                <div class="about-btn text-center">
                                    <router-link :to="{ name : 'home' }" class="default-btn theme_btn theme_btn_bg">
                                        <i class="flaticon-right"></i>
                                        الرجوع الي الصفحة الرئيسية
                                        <span></span>
                                    </router-link>
                                    <br/><br/><br/>
                                </div>
                            </div>
                        </div>
                     
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'errorPayment',
        data(){
            return {
                //
                auth: {
                  access_token: '',
                },
                locale: 'ar',
                hash: '',
                pgLoading: true,
                whatsAppNo: window.whatsAppNo,
            }
        },
        mounted() {},
        created() {     
            //  
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }
            if(localStorage.getItem('locale')) {
                this.locale = localStorage.getItem('locale');
            }

            if(this.$route.query.hash) {
                this.hash = this.$route.query.hash;
            }

            this.fetchData();     
        },
        methods: {
            //
            fetchData() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/donations/payment/failed',
                    method: 'GET',
                    data: {},
                    params: {
                        hash: this.hash
                    }
                }
                this.$axios(options)
                .then(() => {
                    //
                })
                .catch(() => {
                    //
                })
                .finally(() => { });
            },

        },
    }
</script>

<style scoped="">
</style>